import { FaVideo, FaPlayCircle, FaStar } from 'react-icons/fa';

function Info() {
  return (
    <div>
      <div
        style={{
          color: "#333",
          padding: "30px",
          borderRadius: "15px",
          marginTop: "40px",
          textAlign: "center",
          fontSize: "20px",
          }}
      >
        <div style={{ fontSize: "40px", color: "#004085", marginBottom: "15px" }}>
          <FaVideo /> 
        </div>
        <strong>ReciteOnTV Submission Period Has Ended!</strong>
        <br /> <br />
        Jazakhallahu Khairan to everyone who participated!
        <br /> <br />
        Stay tuned for <strong>updates and announcements.</strong>
        <br /> <br />
        May Allah reward all the amazing reciters <FaStar style={{ color: "#f4c542" }} />
      </div>
    </div>
  );
}

export default Info;
